var BlogsFakeData = [
    {
        id: 1,
        image: 'https://i.ibb.co/4SXxRSK/blogs-image-1.jpg',
        blogsTitle: 'Web Developer',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    },
    {
        id: 2,
        image: 'https://i.ibb.co/2Mx31p1/blogs-image-2.jpg',
        blogsTitle: 'Android Developer',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    },
    {
        id: 3,
        image: 'https://i.ibb.co/pdjyqbc/blogs-image-3.jpg',
        blogsTitle: 'Digital Marketing',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    },
    {
        id: 4,
        image: 'https://i.ibb.co/pdjyqbc/blogs-image-3.jpg',
        blogsTitle: 'Web Developer',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    },
    {
        id: 5,
        image: 'https://i.ibb.co/4SXxRSK/blogs-image-1.jpg',
        blogsTitle: 'Android Developer',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    },
    {
        id: 6,
        image: 'https://i.ibb.co/2Mx31p1/blogs-image-2.jpg',
        blogsTitle: 'Digital Marketing',
        blogsDescription: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Similique iusto accusamus odio fugit autem id?'
    }
];

export default BlogsFakeData;